import script from "./AModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AModal.vue?vue&type=script&setup=true&lang=js"

import "./AModal.vue?vue&type=style&index=0&id=0aa135cc&scoped=true&lang=css"

import exportComponent from "/opt/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0aa135cc"]])

export default __exports__